__turbopack_context__.v({
  "buttonsWrapper": "GeneralBanner-module-scss-module__ylvwYG__buttonsWrapper",
  "container": "GeneralBanner-module-scss-module__ylvwYG__container",
  "content": "GeneralBanner-module-scss-module__ylvwYG__content",
  "description": "GeneralBanner-module-scss-module__ylvwYG__description",
  "dismiss": "GeneralBanner-module-scss-module__ylvwYG__dismiss",
  "title": "GeneralBanner-module-scss-module__ylvwYG__title",
});
